// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.toolbar {
  z-index: 100;
  font-size: 13.333333px;
  width: 100%;
}

.toolbar input {
  z-index: 5;
}

.toolbar-item {
  padding: 8px;
}

::ng-deep .mat-mdc-select {
  max-width: unset !important;
}

::ng-deep .mat-mdc-select-panel {
  max-width: unset !important;
}

.description {
  font-size: 10px;
  color: rgba(0, 0, 0, 0.8);
  margin-top: -30px;
}

.candleStickContainer {
  display: block;
  height: 100%;
  width: 100%;
}

.chart-flex-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.chart-flex-wrapper > .scichart {
  flex-grow: 1;
}

.wider {
  min-width: 250px;
}

table {
  width: 100%;
}

.input-header {
  padding: 10px;
}

app-insights-cs-chart {
  margin-bottom: 20px;
}

::ng-deep .mat-mdc-select-panel {
  max-width: unset !important;
}

.change {
  color: black;
  font-size: 14px !important;
}

mat-button-toggle-group {
  vertical-align: top;
}

::ng-deep .editor-container {
  height: 100% !important;
}

ngx-monaco-editor {
  height: 100%;
}

mat-tab-group {
  height: 100%;
}

.chartContainer {
  display: block;
  height: 100%;
  width: 100%;
}

.hidden {
  display: none;
  height: 0;
  width: 0;
}

.impactTab {
  display: block;
  height: 100%;
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/app/components/strategy-grid/model-inputs-widget/model-inputs-widget.component.scss"],"names":[],"mappings":"AAAA;EAIE,YAAA;EACA,sBAAA;EACA,WAAA;AAFF;;AAKA;EACE,UAAA;AAFF;;AAKA;EACE,YAAA;AAFF;;AAKA;EACE,2BAAA;AAFF;;AAKA;EACE,2BAAA;AAFF;;AAKA;EACE,eAAA;EACA,yBAAA;EACA,iBAAA;AAFF;;AAKA;EACE,cAAA;EACA,YAAA;EACA,WAAA;AAFF;;AAKA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AAFF;;AAKA;EACE,YAAA;AAFF;;AAWA;EACE,gBAAA;AARF;;AAWA;EACE,WAAA;AARF;;AAWA;EACE,aAAA;AARF;;AAWA;EACE,mBAAA;AARF;;AAWA;EACE,2BAAA;AARF;;AAWA;EACE,YAAA;EACA,0BAAA;AARF;;AAWA;EACE,mBAAA;AARF;;AAWA;EACE,uBAAA;AARF;;AAWA;EACE,YAAA;AARF;;AAWA;EACE,YAAA;AARF;;AAWA;EACE,cAAA;EACA,YAAA;EACA,WAAA;AARF;;AAWA;EACE,aAAA;EACA,SAAA;EACA,QAAA;AARF;;AAWA;EACE,cAAA;EACA,YAAA;EACA,WAAA;AARF","sourcesContent":[".toolbar {\n  // position: absolute;\n  // margin-top: 21px;\n  // margin-left: 10px;\n  z-index: 100;\n  font-size: 13.333333px;\n  width: 100%;\n}\n\n.toolbar input {\n  z-index: 5;\n}\n\n.toolbar-item {\n  padding: 8px;\n}\n\n::ng-deep .mat-mdc-select {\n  max-width: unset !important;\n}\n\n::ng-deep .mat-mdc-select-panel {\n  max-width: unset !important;\n}\n\n.description {\n  font-size: 10px;\n  color: rgba(0, 0, 0, 0.8);\n  margin-top: -30px;\n}\n\n.candleStickContainer {\n  display: block;\n  height: 100%;\n  width: 100%;\n}\n\n.chart-flex-wrapper {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n.chart-flex-wrapper > .scichart {\n  flex-grow: 1;\n}\n\n// .content {\n//   overflow: auto;\n//   overflow-x: hidden;\n//   height: 100%\n// }\n\n.wider {\n  min-width: 250px;\n}\n\ntable {\n  width: 100%;\n}\n\n.input-header {\n  padding: 10px;\n}\n\napp-insights-cs-chart {\n  margin-bottom: 20px;\n}\n\n::ng-deep .mat-mdc-select-panel {\n  max-width: unset !important;\n}\n\n.change {\n  color: black;\n  font-size: 14px !important;\n}\n\nmat-button-toggle-group {\n  vertical-align: top;\n}\n\n::ng-deep .editor-container {\n  height: 100% !important;\n}\n\nngx-monaco-editor {\n  height: 100%;\n}\n\nmat-tab-group {\n  height: 100%;\n}\n\n.chartContainer {\n  display: block;\n  height: 100%;\n  width: 100%;\n}\n\n.hidden {\n  display: none;\n  height: 0;\n  width: 0;\n}\n\n.impactTab {\n  display: block;\n  height: 100%;\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
